/* import __COLOCATED_TEMPLATE__ from './conversion-modal-trigger.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type CardlessConversionModalService from 'embercom/services/cardless-conversion-modal-service';

export default class ConversionModalTrigger extends Component {
  @service declare cardlessConversionModalService: CardlessConversionModalService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cardless::ConversionModalTrigger': typeof ConversionModalTrigger;
    'cardless/conversion-modal-trigger': typeof ConversionModalTrigger;
  }
}
